'use strict';

import $ from 'jquery';

export default function() {

    $(".cover__control").on("click", function(){
        let anchor = $(this).attr("href");
        $("html, body").stop().animate({
            scrollTop: $(anchor).offset().top
        }, 300);
        return false;
    });
}
